// Screen.js
import React from 'react';

const Disconnectpage = () => {

  return (
    <div className='screen-page py-5'>
      <div className='container'>
        <div className='screen-area'>
          <div className='heading-title fs-2 fw-bold mb-3 text-center'>Device disconnected</div>
          <div className='profile-form-wrapper mx-auto card py-4 px-3 p-md-5 shadow-sm text-center fs-18'>
            <p>You’ve successfully disconnected your mobile device. Thank you!</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Disconnectpage;
